module.exports = __webpack_public_path__ + "static/media/31.7ec1e3a1.mp3";